import { useQuery, gql, ApolloCache } from '@apollo/client';

const mainDirectoryTotalCountQuery = gql`
    query MainDirectorySelection {
        allMainDirectory {
            totalSelectedCount
        }
    }
`;

interface IMainDirectoryTotalCountQueryResult {
    allMainDirectory: {
        __typename: string;
        totalSelectedCount: number;
    };
}

export const useMainDirectorySelectedQuery = () =>
    useQuery<IMainDirectoryTotalCountQueryResult>(mainDirectoryTotalCountQuery, { fetchPolicy: 'cache-first' });

interface IUseMainDirectoryCache {
    listenToCacheChange: () => IMainDirectoryTotalCountQueryResult | null;
    getSelectedAmountFromCache: () => number;
    updateSelectedAmountInCache: (amount: number) => void;
    updateSelectedInCache: (id: string, selected: boolean) => void;
    clearSelectedFromCache: () => void;
}

export const useMainDirectoryCache = (cache: ApolloCache<unknown>): IUseMainDirectoryCache => ({
    listenToCacheChange: () =>
        cache.readQuery<IMainDirectoryTotalCountQueryResult>({
            query: mainDirectoryTotalCountQuery,
            returnPartialData: true,
        }),

    getSelectedAmountFromCache: () => {
        const data = cache.readQuery<IMainDirectoryTotalCountQueryResult>({
            query: mainDirectoryTotalCountQuery,
            returnPartialData: true,
        });

        return data?.allMainDirectory?.totalSelectedCount || 0;
    },

    updateSelectedAmountInCache: (amount: number) => {
        cache.writeQuery<IMainDirectoryTotalCountQueryResult>({
            query: mainDirectoryTotalCountQuery,
            data: {
                allMainDirectory: {
                    __typename: 'DirectoryConnection',
                    totalSelectedCount: amount,
                },
            },
        });
    },

    updateSelectedInCache: (id: string, selected: boolean) => {
        cache.modify({
            id: `Directory:${id}`,
            fields: {
                isSelected: () => selected,
            },
            optimistic: selected,
        });
    },

    clearSelectedFromCache: () => {
        cache.writeQuery<IMainDirectoryTotalCountQueryResult>({
            query: mainDirectoryTotalCountQuery,
            data: {
                allMainDirectory: {
                    __typename: 'DirectoryConnection',
                    totalSelectedCount: 0,
                },
            },
        });
    },
});
